import Head from 'next/head';
import type { GetStaticPaths, GetStaticProps } from 'next';

import Layout from '@/components/layout';
import SiteContextProvider from '@/contexts/siteContext';
import { DEFAULT_REVALIDATE_TIME } from '@/constants';
import Address from '@/components/address/address';
import AboutButtons from '@/components/aboutButtons/aboutButtons';
import MapboxMap from '@/components/mapboxMap/mapboxMap';
import type { SitePageProps, SiteParams } from '@/types';
import { getSingleSiteData } from '@/lib/fetchers/sites';
import { getSiteVenue, isNull } from '@/lib/utils';

export const getStaticPaths: GetStaticPaths<SiteParams> = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<
  SitePageProps,
  SiteParams
> = async ({ params }) => {
  const site = await getSingleSiteData(params?.site);

  return {
    props: { site },
    revalidate: Number.parseInt(
      process.env.ISR_REVALIDATE_TIME || DEFAULT_REVALIDATE_TIME,
    ),
  };
};

const About = ({ site }: SitePageProps) => {
  const venue = getSiteVenue(site);
  const { address } = venue;
  const { latitude, longitude } = address || {};
  const canShowMap = Boolean(
    latitude && longitude && !isNull(latitude) && !isNull(longitude),
  );

  return (
    <SiteContextProvider site={site}>
      <Head>
        <title key="title">
          About / Location / Public Transit / Transportation
        </title>
      </Head>
      <Layout>
        <h1>About</h1>
        <Address />
        <AboutButtons />
        {canShowMap && (
          <div className="mb-5">
            <MapboxMap longitude={longitude!} latitude={latitude!} />
          </div>
        )}
        {site.html_about && (
          <div
            className="server-content"
            dangerouslySetInnerHTML={{ __html: site.html_about }}
          />
        )}
      </Layout>
    </SiteContextProvider>
  );
};

export default About;
